import React, { useState, useRef } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Card,
  CardBody,
  CardText,
  Row,
  Col,
} from "reactstrap";
import Dropzone from "react-dropzone";
import { formatBytes } from "../../../utils/helpers/files/formatBytes";
// xlsx
import ModeloUpload from "../../../assets/statics/modelo_importação_qrcode.xlsx";
import readXlsxFile from "read-excel-file";
// validações
import {
  allExcelColumns,
  findRowsWithError,
  findDuplicateName,
  excelColumnsPtBr,
  findInvalidCodes,
} from "./importValidation";
//service
import { createFunction } from "../../../utils/services/functions";
// components
import ModalExcelRows from "./ModalExcelRows";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";

export default function ModalImportQrCodes(props) {
  const { isOpen, toggle, token, idEvent, getAllFunc } = props;
  // documento
  const [selectedFiles, setselectedFiles] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [totalSended, setTotalSended] = useState(0);
  // botões
  const [btnSend, setBtnSend] = useState(false);
  const [btnCancel, setBtnCancel] = useState(false);
  // importar
  const importActivated = useRef(false);
  // erros
  const [modalErrors, setModalErrors] = useState(false);
  const [errors, setErrors] = useState({});
  // alerta
  const [success, setSuccess] = useState(false);

  function cancelImport() {
    importActivated.current = false;
    setselectedFiles([]);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(false);
    setBtnCancel(false);
  }

  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    setselectedFiles(files);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(true);
  }

  async function uploadService() {
    try {
      importActivated.current = true;
      setBtnSend(false);
      setBtnCancel(true);

      const schema = {
        NomeQRCode: { prop: "nameQrcode", type: String },
        CodigoRanking: { prop: "codeRanking", type: String },
      };

      let count = 0;

      const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

      const readXlsx = async () => {
        try {
          if (!selectedFiles[0]) {
            setErrors({
              type: "text",
              error: "Nenhum arquivo selecionado",
            });
            setModalErrors(true);
            return;
          }

          const { rows } = await readXlsxFile(selectedFiles[0], { schema });

          if (
            !rows ||
            !Array.isArray(rows) ||
            (Array.isArray(rows) && rows.length === 0)
          ) {
            setErrors({
              type: "text",
              error: "Erro ao ler as linhas do arquivo Excel ou arquivo vazio",
            });
            setModalErrors(true);
            return;
          }

          const validateRows = rows.map((row, i) => allExcelColumns(row, i));

          const rowsWithError = findRowsWithError(validateRows);

          if (rowsWithError && rowsWithError.length > 0) {
            setErrors({
              type: "required",
              data: rowsWithError,
            });
            setModalErrors(true);
            return;
          }

          const duplicateName = findDuplicateName(validateRows);

          if (duplicateName && duplicateName.length > 0) {
            setErrors({
              type: "duplicate",
              data: duplicateName,
            });
            setModalErrors(true);
            return;
          }

          const codesInvalids = await findInvalidCodes(
            validateRows,
            idEvent,
            token
          );

          if (codesInvalids && codesInvalids.length > 0) {
            setErrors({
              type: "codeInvalid",
              data: codesInvalids,
            });
            setModalErrors(true);
            return;
          }

          validateRows.forEach(async (row, i) => {
            await sleep(100);
            await submitData(row, i, validateRows.length);
          });
        } catch (error) {
          console.log("erro", error);
        }
      };

      readXlsx();
    } catch {}
  }

  async function submitData(row, index, totalRows) {
    await createFunction({
      eventId: idEvent,
      description: row.nameQrcode,
      type: row.codeRanking,
      functionObject: "--",
      responseObject: "--",
      jwt: token,
    }).then((res) => {
      if (res.message === "CREATED" && index + 1 === totalRows) {
        setSuccess(true);
      }
    });
  }

  return (
    <>
      {success ? (
        <SweetAlert
          success
          title="Upload"
          onConfirm={() => {
            getAllFunc();
            toggle();
            setSuccess(false);
          }}
        >
          O arquivo foi enviado com sucesso!
        </SweetAlert>
      ) : null}

      {modalErrors && (
        <ModalExcelRows
          toggle={() => setModalErrors(false)}
          rows={errors}
          columnNames={excelColumnsPtBr}
        />
      )}

      <Modal isOpen={isOpen} centered>
        <ModalHeader toggle={toggle}>Importar QR Codes</ModalHeader>
        <ModalBody>
          <Card className="p-1">
            <CardBody className="m-1 p-2">
              <CardText className="mb-2 p-10">
                O arquivo a ser importado deve seguir este{" "}
                <a href={ModeloUpload} download="modelo_importação_qrcode.xlsx">
                  Modelo
                </a>
                , não modifique seu cabeçalho.
              </CardText>
            </CardBody>
          </Card>

          {selectedFiles.length === 0 && (
            <Dropzone
              onDrop={(acceptedFiles) => {
                handleAcceptedFiles(acceptedFiles);
              }}
            >
              {({ getRootProps, getInputProps }) => (
                <div className="dropzone">
                  <div
                    className="dz-message needsclick mt-1"
                    {...getRootProps()}
                  >
                    <input {...getInputProps()} />
                    <div className="mb-4">
                      <i className="display-4 text-muted bx bxs-cloud-upload" />
                      <h4>Arraste o arquivo ou clique aqui e selecione.</h4>
                    </div>
                  </div>
                </div>
              )}
            </Dropzone>
          )}

          <div className="dropzone-previews mt-0" id="file-previews">
            {selectedFiles.map((f, i) => {
              return (
                <Card
                  className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                  key={i + "-file"}
                >
                  <div className="p-1">
                    <Row className="align-items-center">
                      <Col xs="11">
                        <strong>{`Nome: ${f.name} - Tamanho: ${f.formattedSize}`}</strong>
                      </Col>
                      <Col xs="1">
                        <span
                          style={{
                            fontSize: "16px",
                            color: "red",
                            fontWeight: "700",
                          }}
                          className="mdi mdi-close"
                          onClick={() => setselectedFiles([])}
                        />
                      </Col>
                    </Row>
                    {importActivated.current && (
                      <Row className="align-items-center">
                        <Col>
                          <strong>{`Total enviado: ${totalSended}/${totalRows}`}</strong>
                        </Col>
                      </Row>
                    )}
                  </div>
                </Card>
              );
            })}
          </div>

          <div className="text-center mt-3">
            <button
              type="button"
              disabled={!btnSend || selectedFiles.length === 0}
              className="btn btn-primary waves-effect waves-light"
              onClick={() => uploadService()}
            >
              Enviar QR Codes
            </button>
            <button
              type="button"
              className="btn btn-danger mx-1"
              disabled={!btnCancel}
              onClick={() => cancelImport()}
            >
              Cancelar
            </button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}
